import { useState, useRef, useEffect } from "react";
import styles from "./styles.module.scss";
import LandingHeader from "component/Common/LandingHeader";
import LandingFooter from "component/Common/LandingFooter";
import ScrollContext from "context/scrollContext";
import { Helmet } from "react-helmet-async";

export const PolicyLayout = (props) => {
  const appDemoScrollRef = useRef();
  const landingHeaderRef = useRef();
  const [shouldScroll, setShouldScroll] = useState(false);
  const [isAppView, setIsAppView] = useState(false);

  // On initial mount, check sessionStorage and URL params
  useEffect(() => {
    // Check if app=true parameter exists in URL
    const params = new URLSearchParams(window.location.search);
    setIsAppView(params.get("isApp") === "true");

    if (sessionStorage.getItem("scrollToTarget")) {
      sessionStorage.removeItem("scrollToTarget");
      setShouldScroll(true);
    }
  }, []);

  // Watch for scrollRef being assigned AND scroll intent being true
  useEffect(() => {
    if (shouldScroll) {
      const interval = setInterval(() => {
        if (appDemoScrollRef.current) {
          handleScroll();
          setShouldScroll(false);
          clearInterval(interval);
        }
      }, 50);
      return () => clearInterval(interval);
    }
  }, [shouldScroll]);

  // reactively waits for ref

  const handleScroll = () => {
    appDemoScrollRef?.current?.scrollToTarget(); // calling child method
  };

  return (
    <ScrollContext.Provider value={{ appDemoScrollRef, handleScroll }}>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <div className="w-full m-0">
        {!isAppView && (
          <LandingHeader handleScroll={handleScroll} landingHeaderRef={landingHeaderRef} />
        )}
        <>{props.children}</>
        {!isAppView && <LandingFooter />}
      </div>
    </ScrollContext.Provider>
  );
};
